import React, { useState } from "react";

//UI Material
import { Box, Card, Grid, Tab, Tabs } from "@mui/material";

//Helpers
import {
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";

//Local components
import StationsGraph from "../Graphs/StationsGraph";
import AccesoriesGraph from "../Graphs/AccesoriesGraph";

//Function to generate tabs
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`specific-products-tabpanel-${index}`}
      aria-labelledby={`specific-products-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{typographyForText(children)}</Box>}
    </div>
  );
}

export default function SpecificMonthlyProduction({ data, year }) {
  // ==========> Component States <==========
  //State for graph variant
  const [type, setType] = useState(0);

  // ==========> Component Functions <==========
  //Function to set tab value
  const handleChange = (_event, newValue) => {
    setType(newValue);
  };
  const changeTab = handleChange;

  //Function for giving an index to each tab
  function a11yProps(index) {
    return {
      id: `specific-products-tab-${index}`,
      "aria-controls": `specific-products-tabpanel-${index}`,
    };
  }

  // ==========> Component <==========
  return (
    <Card raised sx={{ height: "100%" }}>
      <Grid container spacing={1} textAlign="center" sx={{ padding: "15px" }}>
        <Grid item xs={12}>
            {typographyForSubtitles(
              `Producción Específica mensual de ${year}`,
              "secondary"
            )}
        </Grid>
        <Grid item xs={12}>
          <Box>
            <Tabs
              centered
              indicatorColor="secondary"
              textColor="secondary"
              value={type}
              onChange={changeTab}
              aria-label="product-tabs"
            >
              <Tab
                label="Estaciones"
                sx={{ fontSize: "11px" }}
                {...a11yProps(0)}
              />
              <Tab
                label="Accesorios"
                sx={{ fontSize: "11px" }}
                {...a11yProps(1)}
              />
            </Tabs>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <TabPanel value={type} index={0}>
            <StationsGraph data={data} year={year} />
          </TabPanel>
          <TabPanel value={type} index={1}>
            <AccesoriesGraph data={data} year={year} />
          </TabPanel>
        </Grid>
      </Grid>
    </Card>
  );
}
